import * as config from 'customerConfig';
import { lighten } from 'material-ui/utils/colorManipulator';

const getTheme = () => {
  let customerTheme = {};
  try {
    customerTheme = JSON.parse(config.theme);
  } catch (ex) {
    console.log(`error parsing theme: ${ex}`);
  }
  const primaryColor = '#3B53A7';
  return {
    ...customerTheme,
    mainButton: (customerTheme.mainButton || primaryColor),
    primary1Color: (customerTheme.primary1Color || primaryColor),
    primary2Color: lighten((customerTheme.primary2Color || primaryColor), 0.15),
    primary3Color: lighten((customerTheme.primary3Color || primaryColor), 0.6),
    loginColor: (customerTheme.loginColor || primaryColor),
  };
};

const getHiddenFeatures = () => {
  let customerFeatures = {};
  try {
    customerFeatures = JSON.parse(config.hiddenFeatures);
  } catch (ex) {
    console.log(`error parsing hidden features: ${ex}`);
  }

  return {
    appraisals: (customerFeatures.appraisals === 'true'),
  };
};

/* eslint import/prefer-default-export: 0 */
const settings = {
  apiUrl: config.apiUrl,
  supportEmail: (config.supportEmail || 'applicon@applicon.is'),
  customer: config.customer,
  /* eslint global-require: 0 */
  logo: require('assets/dev/logo.png'), // eslint-disable-line import/no-dynamic-require
  logoWidth: (config.logoWidth || 193),
  theme: getTheme(),
  useSSO: (config.useSSO === 'true'),
  useMobileLogin: (config.useMobileLogin === 'true'),
  hideXapLogin: (config.hideXapLogin === 'true'),
  tags: (config.tags || [config.customer]),
  server: config.server,
  destination: config.destination,
  hiddenFeatures: getHiddenFeatures(),
  reverseListItemLabels: (config.reverseListItemLabels === 'true'),
  msalTenantID: config.msalTenantID,
  msalApplicationID: config.msalApplicationID,
  msalScope: config.msalScope,
  applicationInsightsInstrumentationKey: config.applicationInsightsInstrumentationKey,
  siteName: config.siteName,
  recaptchaKey: config.recaptchaKey,
};

export const apiUrl = settings.apiUrl;
export const supportEmail = settings.supportEmail;
export const customer = settings.customer;
export const logo = settings.logo;
export const logoWidth = settings.logoWidth;
export const theme = settings.theme;
export const useSSO = settings.useSSO;
export const hideXapLogin = settings.hideXapLogin;
export const tags = settings.tags;
export const server = settings.server;
export const destination = settings.destination;
export const hiddenFeatures = settings.hiddenFeatures;
export const reverseListItemLabels = settings.reverseListItemLabels;
export const msalTenantID = settings.msalTenantID;
export const msalApplicationID = settings.msalApplicationID;
export const msalScope = settings.msalScope;
export const applicationInsightsInstrumentationKey = settings.applicationInsightsInstrumentationKey;
export const siteName = settings.siteName;
export const recaptchaKey = settings.recaptchaKey;
export const useMobileLogin = settings.useMobileLogin;



// WEBPACK FOOTER //
// ./src/utils/settings.js